import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "text-center"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ItemCatalogsDetails = _resolveComponent("ItemCatalogsDetails")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    show: _ctx.show,
    title: _ctx.item?.alternateProductId || _ctx.item?.productId,
    xl: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        (_ctx.item)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_ItemCatalogsDetails, {
                item: _ctx.item,
                t: _ctx.t,
                "all-catalogs": _ctx.allCatalogs,
                "instance-id": _ctx.instanceId,
                onNavigate: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('hidden')))
              }, null, 8, ["item", "t", "all-catalogs", "instance-id"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      ])
    ]),
    _: 1
  }, 8, ["show", "title"]))
}